import { Directive, ElementRef, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
    selector: '[app-input-uppercase]',
    standalone: false,
})
export class InputUppercaseDirective {

    constructor(private el: ElementRef,
        private ctrl: NgControl) {
    }

    @HostListener('input', ['$event'])
    onInput(): void {
        const inputEl = this.el.nativeElement;
        const start = inputEl.selectionStart;
        const end = inputEl.selectionEnd;

        // Salva valor original antes da transformação
        const original = inputEl.value;
        const uppercased = original.toUpperCase();
        if (original !== uppercased) {
            this.ctrl.control?.setValue(uppercased, { emitEvent: false });
            inputEl.setSelectionRange(start, end);
        }

        // // Aplica a transição visual leve antes da conversão real
        // setTimeout(() => {
        // }, 10); // Delay suave para efeito de digitação
    }

}